module.exports = __webpack_public_path__ + "img/video_poster.14b20fb7.jpg";